/* Urban Lux — comportamiento ligero: reveal al hacer scroll + cuentas atrás reales */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.ul-reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { el.classList.add('ul-armed'); io.observe(el); });
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-ul-end]');
    if (!nodes.length) return;
    function tick() {
      var now = Date.now();
      nodes.forEach(function (n) {
        var end = parseInt(n.getAttribute('data-ul-end'), 10);
        var left = Math.max(0, end - now);
        var d = Math.floor(left / 86400000);
        var h = Math.floor(left / 3600000) % 24;
        var m = Math.floor(left / 60000) % 60;
        var s = Math.floor(left / 1000) % 60;
        var set = function (sel, v) { var i = n.querySelector(sel); if (i) i.textContent = v; };
        set('[data-d]', d + 'd'); set('[data-h]', pad(h) + 'h'); set('[data-m]', pad(m) + 'm'); set('[data-s]', pad(s) + 's');
        if (left === 0) { var bar = n.closest('.ul-campaign-bar, .ul-campaign-banner'); if (bar) bar.style.display = 'none'; }
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function boot() { initReveal(); initCountdowns(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
